import UserProfileClient from "../lib/apiClients/roofSnapApiClient/userProfileClient";
import {
    CALL_API
} from "../middleware/api";
import {
    GET_USER_PROFILE_FAILURE,
    GET_USER_PROFILE_REQUEST,
    GET_USER_PROFILE_SUCCESS
} from "./actionTypes";

export const getUserProfile = (userId) => {
    const userProfileClient = new UserProfileClient('v1');
    const request = userProfileClient.getUserProfile;

    return {
        [CALL_API]: {
            types: [
                GET_USER_PROFILE_REQUEST,
                GET_USER_PROFILE_SUCCESS,
                GET_USER_PROFILE_FAILURE,
            ],
            request,
            params: {
                id: userId,
            }
        }
    }
};
